// Data hooks for the "browse by switch" feature: the picker grid (live —
// the per-switch online counts and uplink-ONU flags move on each OLT poll
// cycle, so we re-fetch on the `olts` / `oltissues` SSE channels) and the
// per-switch user list (fetched on demand when the dialog opens).

import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { qk } from "@/lib/queryKeys";
import { useEventStream } from "@/lib/sse";

export function useSwitchList() {
  const qc = useQueryClient();
  useEventStream(["olts", "oltissues"], () => {
    void qc.invalidateQueries({ queryKey: qk.switches.list() });
  });
  return useQuery({
    queryKey: qk.switches.list(),
    queryFn: () => api.switches.list(),
    staleTime: 30_000,
    refetchInterval: 120_000, // safety net; SSE drives the fast path
  });
}

export function useSwitchUsers(name: string | null) {
  return useQuery({
    queryKey: qk.switches.users(name ?? ""),
    queryFn: () => api.switches.users(name as string),
    enabled: !!name,
    staleTime: 15_000,
  });
}
